var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breakdance-color-swatch",class:{
    'breakdance-color-swatch--rounded': _vm.rounded,
    [`breakdance-color-swatch--light`]: _vm.light
  },attrs:{"data-test-id":"breakdance-color-swatch"}},[_c('button',_vm._g({staticClass:"breakdance-color-swatch__color",style:({ background: _vm.colorCode || 'transparent' })},_vm.$listeners))])
}
var staticRenderFns = []

export { render, staticRenderFns }